export default "<payment-partners\n  model=\"vm.model.debitsBlacklist\"\n  form=\"vm.form\">\n</payment-partners>\n";